export default __webpack_public_path__ + "i18n/translations/translation-ml.7d621229.json";